module.exports = __webpack_public_path__ + "static/aleks_video-06286cf1e41baf7e11a29403217a5aa1.png";